export const cnpjMask = '99.999.999/9999-99'
export const cpfMask = '999.999.999-99'
export const phoneMask = '(99) 9999-9999'
export const celMask = '(99) 99999-9999'
export const creditCardMask = '9999 9999 9999 9999'
export const cepMask = '99999-999'
export const dateMask = '99/99/9999'
export const integerMask = '999999999'
export const hourMask = '99:99'

export const maskCpfCnpj = (num) => {
  let v = num

  if (num) {
    v = v.toString()
    v = v.replace(/\D/gu, '')

    switch (v.length) {
      case 4:
        v = v.replace(/(\d+)(\d{3})/u, ' $1.$2')

        break
      case 5:
        v = v.replace(/(\d+)(\d{3})/u, ' $1.$2')

        break
      case 6:
        v = v.replace(/(\d+)(\d{3})/u, ' $1.$2')

        break
      case 7:
        v = v.replace(/(\d+)(\d{3})(\d{3})/u, ' $1.$2.$3')

        break
      case 8:
        v = v.replace(/(\d+)(\d{3})(\d{3})/u, ' $1.$2.$3')

        break
      case 9:
        v = v.replace(/(\d+)(\d{3})(\d{3})/u, ' $1.$2.$3')

        break
      case 10:
        v = v.replace(/(\d+)(\d{3})(\d{3})(\d{1})/u, ' $1.$2.$3-$4')

        break
      case 11:
        v = v.replace(/(\d+)(\d{3})(\d{3})(\d{2})/u, ' $1.$2.$3-$4')

        break
      case 12:
        v = v.replace(/(\d+)(\d{3})(\d{3})(\d{4})/u, ' $1.$2.$3/$4')

        break
      case 13:
        v = v.replace(/(\d+)(\d{3})(\d{3})(\d{4})(\d{2})/u, ' $1.$2.$3/$4-$5')

        break
      case 14:
        v = v.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d+)/u, ' $1.$2.$3/$4-$5')

        break
      default:
    }
  }

  return v
}

export const numberFormat = (num) => {
  return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
}

export const StringFormat = {
  cep: (value) => {
    value = value.replace(/\D/g, '')
    value = value.replace(/^(\d{5})(\d)/, '$1-$2')
    return value
  },
  currency: (value) => {
    value = value.replace(/\D/g, '')
    value = value.replace(/(\d)(\d{2})$/, '$1,$2')
    value = value.replace(/(?=(\d{3})+(\D))\B/g, '.')
    return value
  },
  parseCurrency: (value) => {
    value = value.replace(/\D/g, '')
    value = value.replace(/(\d)(\d{2})$/, '$1.$2')
    return value
  },
  number: (value) => {
    value = value.replace(/\D/g, '')
    return value
  },
  cpf: (value) => {
    value = value.replace(/\D/g, '')
    value = value.replace(/(\d{3})(\d)/, '$1.$2')
    value = value.replace(/(\d{3})(\d)/, '$1.$2')
    value = value.replace(/(\d{3})(\d{2})$/, '$1-$2')
    return value
  },
  cnpj: (value) => {
    value = value.replace(/\D/g, '')
    value = value.replace(/(\d{2})(\d)/, '$1.$2')
    value = value.replace(/(\d{3})(\d)/, '$1.$2')
    value = value.replace(/(\d{3})(\d)/, '$1/$2')
    value = value.replace(/(\d{4})(\d)/, '$1-$2')
    return value
  },
  date: (value) => {
    value = value.replace(/\D/g, '')
    value = value.replace(/(\d{2})(\d)/, '$1/$2')
    value = value.replace(/(\d{2})(\d)/, '$1/$2')
    value = value.replace(/(\d{2})(\d{4})$/, '$1/$2')
    return value
  },
  hour: (value) => {
    value = value.replace(/\D/g, '')
    value = value.replace(/(\d{2})(\d)/, '$1:$2')
    return value
  },
  cel: (value) => {
    value = value.replace(/\D/g, '')
    // value = value.replace(/(\d{2})(\d)/, '($1) $2')
    value = value.replace(/(\d{5})(\d)/, '$1-$2')
    return value
  },
  phone: (value) => {
    value = value.replace(/\D/g, '')
    // value = value.replace(/(\d{2})(\d)/, '($1) $2')
    value = value.replace(/(\d{4})(\d)/, '$1-$2')
    return value
  },
  phoneUS: (value) => {
    value = value.replace(/\D/g, '')
    value = value.replace(/(\d{3})(\d)/, '($1) $2')
    value = value.replace(/(\d{3})(\d)/, '$1-$2')
    return value
  },
}

export const Mask = {
  cep: (e) => {
    e.currentTarget.maxLength = 9
    const value = StringFormat.cep(e.currentTarget.value)
    e.currentTarget.value = value
    return e
  },
  currency: (e) => {
    const value = StringFormat.currency(e.currentTarget.value)
    e.currentTarget.value = value
    return e
  },
  number: (e) => {
    const value = StringFormat.number(e.currentTarget.value)
    e.currentTarget.value = value
    return e
  },
  cpf: (e) => {
    e.currentTarget.maxLength = 14
    const value = StringFormat.cpf(e.currentTarget.value)
    e.currentTarget.value = value
    return e
  },
  cnpj: (e) => {
    e.currentTarget.maxLength = 18
    const value = StringFormat.cnpj(e.currentTarget.value)
    e.currentTarget.value = value
    return e
  },
  date: (e) => {
    e.currentTarget.maxLength = 10
    const value = StringFormat.date(e.currentTarget.value)
    e.currentTarget.value = value
    return e
  },
  hour: (e) => {
    e.currentTarget.maxLength = 5
    const value = StringFormat.hour(e.currentTarget.value)
    e.currentTarget.value = value
    return e
  },
  cel: (e) => {
    e.currentTarget.maxLength = 10
    const value = StringFormat.cel(e.currentTarget.value)
    e.currentTarget.value = value
    return e
  },
  phone: (e) => {
    e.currentTarget.maxLength = 9
    const value = StringFormat.phone(e.currentTarget.value)
    e.currentTarget.value = value
    return e
  },
  phoneUS: (e) => {
    e.currentTarget.maxLength = 14
    const value = StringFormat.phoneUS(e.currentTarget.value)
    e.currentTarget.value = value
    return e
  },
}
